export const timeline = [
  {
    date: "2026-08-27",
    title: "争议起点：一段直播片段被剪成短视频",
    desc: "一段被剪辑过的直播片段开始在多个平台流传，脱离原始语境后迅速引发讨论。",
    level: "已证实",
  },
  {
    date: "2026-08-29",
    title: "首份工作室声明发布",
    desc: "工作室发布文字声明，否认部分传言，并表示相关内容已被取证，保留法律追究权利。",
    level: "已证实",
  },
  {
    date: "2026-09-01",
    title: "匿名爆料集中出现",
    desc: "多组匿名账号发布所谓聊天记录与截图，来源无法核实，时间线存在明显矛盾。",
    level: "待确认",
  },
  {
    date: "2026-09-03",
    title: "当事人二次回应",
    desc: "灵灵本人发布补充说明，承认部分表述引起误解，但对核心指控仍未正面回应。",
    level: "已证实",
  },
  {
    date: "2026-09-05",
    title: "平台对部分内容作出处理",
    desc: "多个平台对明显失实的搬运内容做了限制推荐处理，账号本身状态未发生变化。",
    level: "已证实",
  },
  {
    date: "2026-09-08",
    title: "事件进入证据核查阶段",
    desc: "讨论焦点从情绪对线转向时间戳比对与来源核对，出现若干条被证伪的「实锤」。",
    level: "待确认",
  },
];